/* B1 COD — barra con contador, reseñas "ver más" y pop-up de salida. */
(function () {
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  /* Barra superior: contador hasta medianoche (no se reinicia al recargar) + fija al hacer scroll */
  function topbar(bar) {
    if (bar.__b1c) return; bar.__b1c = true;
    var cd = bar.querySelector('[data-b1c-countdown]');
    if (cd) {
      var tick = function () {
        var now = new Date(), end = new Date(now); end.setHours(24, 0, 0, 0);
        var s = Math.max(0, Math.floor((end - now) / 1000));
        cd.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor(s / 60) % 60) + ':' + pad(s % 60);
      };
      tick(); setInterval(tick, 1000);
    }
    if (bar.hasAttribute('data-sticky')) {
      var holder = bar.parentNode, top = 0;
      var measure = function () { if (!bar.classList.contains('is-fixed')) top = bar.getBoundingClientRect().top + window.scrollY; };
      var onScroll = function () {
        var fix = window.scrollY > top;
        if (fix !== bar.classList.contains('is-fixed')) {
          holder.style.minHeight = fix ? bar.offsetHeight + 'px' : '';
          bar.classList.toggle('is-fixed', fix);
        }
      };
      measure(); window.addEventListener('resize', measure); window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    }
  }

  /* Reseñas: muestra N y "Ver más" */
  function reviews(root) {
    if (root.__b1c) return; root.__b1c = true;
    var btn = root.querySelector('[data-b1c-more]'); if (!btn) return;
    btn.addEventListener('click', function () {
      var hidden = root.querySelectorAll('.b1c-rv[hidden]'), step = parseInt(btn.getAttribute('data-step') || '3', 10);
      for (var i = 0; i < hidden.length && i < step; i++) hidden[i].hidden = false;
      if (root.querySelectorAll('.b1c-rv[hidden]').length === 0) btn.remove();
    });
  }

  /* Pop-up de salida: una vez por sesión. Escritorio: el cursor sale por arriba. Móvil: sube rápido tras pasar la mitad. */
  function exitPopup(dlg) {
    if (dlg.__b1c || !dlg.showModal) return; dlg.__b1c = true;
    var key = 'b1c-exit-' + (dlg.getAttribute('data-key') || '');
    var seen = function () { try { return sessionStorage.getItem(key); } catch (e) { return null; } };
    var open = function () {
      if (seen() || dlg.open) return;
      try { sessionStorage.setItem(key, '1'); } catch (e) {}
      dlg.showModal();
    };
    var armed = false; setTimeout(function () { armed = true; }, 8000);
    document.addEventListener('mouseout', function (e) { if (armed && !e.relatedTarget && e.clientY <= 0) open(); });
    var lastY = window.scrollY, maxY = 0;
    window.addEventListener('scroll', function () {
      var y = window.scrollY; maxY = Math.max(maxY, y);
      if (armed && maxY > document.body.scrollHeight * 0.5 && lastY - y > 120) open();
      lastY = y;
    }, { passive: true });
    dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.hasAttribute('data-b1c-close')) dlg.close(); });
    dlg.querySelectorAll('[data-b1-scroll-buy]').forEach(function (a) { a.addEventListener('click', function () { dlg.close(); }); });
    // Con checkout propio: el código del pop-up se guarda y viaja al checkout, que cobra el precio especial.
    dlg.querySelectorAll('[data-b1c-exit-code]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var main = document.querySelector('[data-b1c-checkout]');
        if (!main) return; // sin checkout propio: sigue el descuento de Shopify
        e.preventDefault();
        try { sessionStorage.setItem('b1c_code', a.getAttribute('data-b1c-exit-code')); } catch (err) {}
        dlg.close();
        var to = document.getElementById('b1-buy') || main;
        to.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }


  /* Checkout propio: guarda el origen del anuncio y lo pasa al checkout junto con la cantidad del combo */
  var ATTR = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'ttclid'];
  function attribution() {
    var saved = {};
    try { saved = JSON.parse(sessionStorage.getItem('b1c_attr') || '{}'); } catch (e) {}
    var p = new URLSearchParams(location.search);
    ATTR.forEach(function (k) { if (p.get(k)) saved[k] = p.get(k); });
    saved.lp = location.pathname; // página del producto que se está viendo
    try { sessionStorage.setItem('b1c_attr', JSON.stringify(saved)); } catch (e) {}
    return saved;
  }
  function checkoutLink(a) {
    if (a.__b1c) return; a.__b1c = true;
    var base = a.getAttribute('href');
    var box = a.closest('[data-b1-buy]');
    function update() {
      try {
        var u = new URL(base, location.href), q = box && box.querySelector('input[name="quantity"]');
        u.searchParams.set('qty', q ? q.value : '1');
        // Producto de esta landing (si la URL no es el enlace antiguo /purge) y variante elegida
        if (!/\/purge\/?$/.test(u.pathname)) {
          if (a.getAttribute('data-handle')) u.searchParams.set('p', a.getAttribute('data-handle'));
          if (a.getAttribute('data-shop')) u.searchParams.set('s', a.getAttribute('data-shop'));
          var idEl = box && box.querySelector('[name="id"]');
          var vid = (idEl && idEl.value) || a.getAttribute('data-variant');
          if (vid) u.searchParams.set('variant', vid);
          // Botón checkout suelto: solo 1 unidad y/o sin «unidad extra» (respaldo si el checkout no puede leer el tema)
          if (a.hasAttribute('data-one')) u.searchParams.set('one', '1');
          if (a.hasAttribute('data-noextra')) u.searchParams.set('noextra', '1');
        }
        var saved = ''; try { saved = sessionStorage.getItem('b1c_code') || ''; } catch (e) {}
        if (saved && !u.searchParams.get('code')) u.searchParams.set('code', saved); // código del pop-up de salida
        var at = attribution();
        Object.keys(at).forEach(function (k) { if (!u.searchParams.get(k)) u.searchParams.set(k, at[k]); });
        a.href = u.toString();
      } catch (e) {}
    }
    update();
    a.addEventListener('pointerdown', update, true);
    // El tema abre los enlaces externos en pestaña nueva: el checkout va en la MISMA pestaña.
    a.addEventListener('click', function (e) {
      if (e.ctrlKey || e.metaKey || e.shiftKey || e.button === 1) return;
      update();
      e.preventDefault();
      e.stopImmediatePropagation();
      window.location.href = a.href;
    }, true);
    a.removeAttribute('target');
  }

  function init() {
    document.querySelectorAll('[data-b1c-topbar]').forEach(topbar);
    document.querySelectorAll('[data-b1c-reviews]').forEach(reviews);
    document.querySelectorAll('[data-b1c-exit]').forEach(exitPopup);
    document.querySelectorAll('[data-b1c-checkout]').forEach(checkoutLink);
    attribution();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
